import React from "react";
import { Nfc, ShieldCheck } from "lucide-react";
import { companyConfig } from "@/config/companyConfig";

const cardFaces = [
  { tone: "digital", caption: "Tarjeta digital", label: "DIGITALIZACIÓN", logo: "/assets/logos/captec-logo-white.png" },
  { tone: "physical", caption: "Emisión física", label: "MEDIOS DE PAGO", logo: "/assets/logos/captec-logo-white.png" },
];

// A decorative illustration, not a payment form or a live financial dashboard.
// Both card faces share markup and existing assets; no canvas or animation loop.
export default function PaymentCardShowcase() {
  return (
    <div className="payment-card-showcase" role="img" aria-label="Ilustración de tarjetas físicas y digitales CAPTEC">
      {cardFaces.map(({ tone, caption, label, logo }) => (
        <div className={`payment-card payment-card--${tone}`} key={tone} aria-hidden="true">
          <div className="payment-card__top">
            <img className="payment-card__logo" src={logo} alt="" draggable="false" />
            <span className="payment-card__caption">{caption}</span>
          </div>
          <div className="payment-card__technology">
            <img src="/assets/cards/captec-card-chip.png" alt="" className="payment-card__chip" draggable="false" />
            <Nfc className="payment-card__contactless" strokeWidth={1.25} />
          </div>
          <div className="payment-card__number">•••• •••• •••• ••••</div>
          <div className="payment-card__bottom">
            <span>{label}</span>
            <span className="payment-card__brand-mark" />
          </div>
        </div>
      ))}
      
    </div>
  );
}
